import * as React from "react";
class ErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      error: void 0,
      errorInfo: void 0
    };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }
  render() {
    const { error, errorInfo } = this.state;
    return this.props.children(error, errorInfo);
  }
}
export {
  ErrorBoundary as default
};
//# sourceMappingURL=ErrorBoundary.js.map
